import { Command } from './Command';

/**
 * CompoundCommand - Executes multiple commands as a single operation
 * Used for: Multi-selection operations (delete multiple, move multiple, etc.)
 *
 * This allows atomic undo/redo of batch operations - all commands are
 * executed/undone together as one unit.
 *
 * @example
 * const commands = [
 *   new DeleteObjectCommand(canvas, rect1),
 *   new DeleteObjectCommand(canvas, rect2),
 *   new DeleteObjectCommand(canvas, circle1),
 * ];
 * const compound = new CompoundCommand(commands, 'Delete 3 objects');
 * commandStack.execute(compound);
 */
export class CompoundCommand extends Command {
  /**
   * @param {Command[]} commands - Array of commands to execute together
   * @param {string} [description='Compound operation'] - Description of the compound operation
   */
  constructor(commands = [], description = 'Compound operation') {
    super();
    this.commands = commands;
    this.description = description;
  }

  execute() {
    this.commands.forEach(cmd => cmd.execute());
  }

  undo() {
    // Undo in reverse order (LIFO)
    [...this.commands].reverse().forEach(cmd => cmd.undo());
  }

  getDescription() {
    return `${this.description} (${this.commands.length} operations)`;
  }
}
